"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** DownloadIcon */
var DownloadIcon = function DownloadIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement("title", null, "download"), _react.default.createElement("path", {
    d: "M3 3h6.006l1.973 2.002H15v9.994H3V3zm.99 1v9.996h10.02V6.002h-3.465L8.601 4H3.99zm5.576 7.279l1.48-1.469.66.8L9 13.257l-2.739-2.875.711-.732 1.544 1.668-.046-.068V6.56l1.096.018v4.7z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd"
  }));
};

exports.DownloadIcon = DownloadIcon;
DownloadIcon.displayName = "DownloadIcon";
//# sourceMappingURL=DownloadIcon.js.map